import React, { useContext, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { useLoadScript } from '@react-google-maps/api'
import ReactGA from 'react-ga'
import { ApiProvider } from './hooks/api'
import { NotificationsProvider } from './hooks/notifications'
import Routes from './routes'
import { ApiContext } from './hooks/api'
import App from './components/App'
import Spinner from './components/Spinner'

import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bulma/css/bulma.min.css'
import './app.css'
import { signOut } from 'firebase/auth'
import { auth } from './firebase'
import { Toaster } from 'react-hot-toast'
import { useOnlineStatus } from './hooks/useOnlineStatus'
import 'antd/dist/reset.css'
import { MapProvider } from './hooks/MapContext'

const { GOOGLE_ANALYTICS_ID, GOOGLE_MAPS_API_KEY } = window.appConfig
const libraries = ['places']

function GoogleMapsProvider({ children }) {
  useOnlineStatus()
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries
  })

  if (loadError) {
    console.error(loadError)
  }

  if (!isLoaded && !loadError) {
    return <Spinner />
  }

  return (
    <MapProvider>
      {children}
    </MapProvider>
  )
}

function GoogleAnalyticsTracker() {
  const userIdSet = useRef(false)
  const { client, user } = useContext(ApiContext)
  const location = useLocation()

  useEffect(() => {
    async function fetchProfile() {
      try {
        if (!user || !user.id) {
          console.warn('No user ID available for profile fetch')
          return
        }
        // Fetch user profile from /users/{user.id}
        const endpoint = `users/${user.id}`
        const response = await client(endpoint, null, 'GET')
        const profile = {
          id: response.name.split('/').pop(), // Extract document ID (user UID)
          email: response.fields.email?.stringValue
        }
        if (GOOGLE_ANALYTICS_ID) {
          ReactGA.set({ userId: profile.id })
        }
      } catch (err) {
        console.error('Error fetching profile for analytics:', err.message)
      }
    }

    if (client && user && !userIdSet.current) {
      fetchProfile()
      userIdSet.current = true
    }
  }, [client, user])

  useEffect(() => {
    const path = location.pathname + location.search
    if (GOOGLE_ANALYTICS_ID) {
      ReactGA.pageview(path)
    }
  }, [location])

  // useEffect(()=>{
  // handleLogout()
  // },[])
  // const handleLogout = () => {
  //   signOut(auth)
  //     .then(() => {
  //       console.log("User signed out");
  //       window.location.reload(); // optional: reload to reflect logout
  //     })
  //     .catch((error) => {
  //       console.error("Error signing out:", error);
  //     });
  // };

  return null
}

if (GOOGLE_ANALYTICS_ID) {
  ReactGA.initialize(GOOGLE_ANALYTICS_ID)
}

ReactDOM.render(
  <BrowserRouter>
    <ApiProvider>
      <GoogleAnalyticsTracker />
      <GoogleMapsProvider>
        <NotificationsProvider>
          <Toaster position='top-center' reverseOrder={false} />
          <App>
            <Routes />
          </App>
        </NotificationsProvider>
      </GoogleMapsProvider>
    </ApiProvider>
  </BrowserRouter>,
  document.getElementById('root')
)
